import styled from "styled-components";

export const Clamp = styled.div.withConfig({
	shouldForwardProp: (prop) => prop !== "size",
})<{ size?: number }>`
	overflow: hidden;
	display: -webkit-box;
	text-overflow: ellipsis;
	-webkit-line-clamp: ${({ size = 2 }) => size};
	-webkit-box-orient: vertical;
`;
